<template>
    <img :class="avatarClass" :src="localUrl ? localUrl : require('./assets/no-photo.jpg')" alt="avatar" class="border-primary rounded-circle" @error="localUrl = null" />
</template>

<script setup>
    import { computed, ref, watch } from 'vue';

    const props = defineProps({
        url: {
            type: String,
            default: null,
        },

        size: {
            type: String,
            default: 'md',
        },
    });

    const localUrl = ref(props.url);

    watch(
        () => props.url,
        () => {
            localUrl.value = props.url;
        },
    );

    const avatarClass = computed(() => {
        return `avatar avatar-${props.size}`;
    });
</script>

<style scoped lang="scss">
    .avatar-10 {
        width: 10px;
    }

    .avatar-20 {
        width: 20px;
    }

    .avatar-30 {
        width: 30px;
    }

    .avatar-40 {
        width: 40px;
    }

    .avatar-50 {
        width: 50px;
    }

    .avatar-60 {
        width: 60px;
    }
</style>
